/* Les assets du theme vivent sous un chemin versionne que seul Liquid
   connait : window.FN_ASSETS est publiee par layout/theme.liquid. */
var FN_A = window.FN_A || function (n) { return (window.FN_ASSETS && window.FN_ASSETS[n]) || n; };

/* ============================================================
   FRAISE NOIRE — BOUTIQUE (filtres + tri)
   Dépend de window.FN (home.js) : PRODUCTS, card, matchCat
   ============================================================ */
(() => {
  'use strict';
  const media = (s, a, t) => (window.FN && window.FN.media) ? window.FN.media(s, a, t) : `<img src="${s}" ${a}>`;
  const FN = window.FN; if (!FN) return;
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  /* Sur Shopify, cette page sert TOUTES les collections. window.FN_COLLECTION
     porte les handles de celle qu'on affiche ; vide (ou absente), on garde le
     catalogue entier — c'est le cas de « Tous les produits », qui reproduit
     alors exactement la boutique de la V2. */
  /* Declaree ICI, avant tout usage : les puces de categorie la lisent des la
     construction du panneau de filtres, bien avant les bannieres. Plus bas,
     elle tombait dans la zone morte temporelle (« Cannot access 'RAYONS'
     before initialization ») et tout shop.js s'arretait. */
  const RAYONS = window.FN_RAYONS || {};

  /* 20/10/2026 — le test portait aussi sur `.length`. Une collection VIDE
     émettait `[]`, donc `.length` valait 0, donc le script croyait être sur la
     boutique entière : /collections/bonnets affichait « Tout » et les 88
     produits. Un TABLEAU, même vide, signifie « on est dans une collection ».
     Seul `null` (la page « toute la boutique ») lève la restriction. */
  const _dansLaCollection = Array.isArray(window.FN_COLLECTION)
    ? new Set(window.FN_COLLECTION) : null;
  const P = FN.PRODUCTS.filter(p => p.img && (!_dansLaCollection || _dansLaCollection.has(p.handle)));

  const CATS = [
    { key: 'all', label: 'Tout' },
    { key: 'Casquettes', label: 'Casquettes' },
    { key: 't-shirt', label: 'T-shirts' },
    { key: 'Hoodies', label: 'Hoodies' },
    { key: 'Ensembles', label: 'Ensembles' },
    { key: 'Survêtements', label: 'Survêtements' },
    { key: 'Jogging', label: 'Jogging' },
    { key: 'Shorts', label: 'Shorts' },
  ];
  const HASH = { casquettes: 'Casquettes', 't-shirts': 't-shirt', tshirts: 't-shirt', hoodies: 'Hoodies', ensembles: 'Ensembles', survetements: 'Survêtements', jogging: 'Jogging', shorts: 'Shorts' };
  const labelOf = k => (CATS.find(c => c.key === k) || {}).label || 'Toute la boutique';

  /* ---------- ORDRE « EN VEDETTE » (tri par defaut) ----------
     L'ordre brut du fichier produits alignait ~10 rangees de casquettes d'affilee
     et enterrait les t-shirts en bas de page. Ici : 16 pieces vitrines qui mixent
     les univers (ancrage cher → desir → accessible), puis le reste du catalogue
     intercale par blocs de categories (plus jamais un mur d'une seule categorie).
     Aucune donnee produit modifiee : uniquement un ordre d'affichage. */
  const FEATURED = [
    'survetement-amsterdam', 'hoodies-design-a-capuche-13mars', 'casquette-brodee-3d-ajustable-black', 't-shirt-the-ruche-blanc',
    'ensemble-t-shirt-short-doodle-rouge-fraise', 'hoodie-design-a-capuche-crime-scene', 'casquette-fraise-gold', 't-shirt-fraise-doodle-fraise-noire-2023',
    'survetement-pink-design-1', 'hoodies-design-a-capuche-99japon', 'casquette-abeille-orange', 'short-de-bain-rouge',
    'ensemble-t-shirt-short-drip-noir', 't-shirt-avatar-design-fraise-noire-2023', 'casquette-ajustable-rien-100-rien-fraise-noire-2023', 'hoodie-basique-light-jade-a-capuche',
  ];
  const RANK = (() => {
    const rank = new Map();
    let n = 0;

    /* DANS UN RAYON : on reprend EXACTEMENT l'ordre rendu par le serveur.
       Le theme range les casquettes par famille (les pailletees ensemble, les
       holographiques ensemble...) avant meme d'envoyer la page. Recalculer un
       ordre ici en produisait un autre, legerement different : la grille se
       reorganisait sous les yeux du client au chargement, ce qui donne
       l'impression qu'elle n'est pas triee. Une seule source : le serveur. */
    if (_dansLaCollection) {
      window.FN_COLLECTION.forEach(h => rank.set(h, n++));
      return rank;
    }

    /* La vitrine (seize pieces qui melangent les univers) n'a de sens que sur la
       boutique entiere. Dans un RAYON, elle epinglait quatre casquettes en tete,
       hors de leur famille : une pailletee se retrouvait loin de l'autre. */
    if (!_dansLaCollection) {
      FEATURED.forEach(h => { if (P.some(p => p.handle === h)) rank.set(h, n++); });
    }
    // reste du catalogue : round-robin par blocs de 3 pieces max par categorie.
    // Les casquettes (25 restantes, categorie la plus profonde) sont traitees a part :
    // un simple round-robin epuisait les autres categories avant elles et laissait
    // un mur de ~16 casquettes en queue de grille. Ici : blocs de 3 casquettes
    // intercales a intervalle regulier sur toute la longueur — plus jamais de mur.
    const rest = P.filter(p => !rank.has(p.handle));
    const byCat = new Map();
    rest.forEach(p => { const k = p.cat || 'autre'; if (!byCat.has(k)) byCat.set(k, []); byCat.get(k).push(p); });
    /* ---------- FAMILLES DE CASQUETTES ----------
       Vingt-neuf casquettes triees par PRIX (le reglage de la collection
       Shopify) : les deux pailletees se retrouvaient a trois rangees l'une de
       l'autre, les abeilles separees, les holographiques eparpillees. On les
       regroupe par famille — une pailletee a cote de l'autre pailletee — sans
       toucher aux donnees produit : c'est un ordre d'affichage.
       Les tris explicites (prix, A→Z) restent prioritaires, evidemment. */
    const sansAccent = t => t.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const FAMILLES = [
      { cle: 'brodee 3d',   test: t => /brodee? 3d/.test(t) },
      { cle: 'classics',    test: t => /classics/.test(t) },
      /* Blue Magic ouvre les lettrages : elle precede « 2085 » FUTURE, comme
         dans le rayon « Casquettes lettrees » (demande de Hedy, 2026-10-06). */
      { cle: 'blue magic',  test: t => /blue magic/.test(t) },
      { cle: 'lettrage',    test: t => /(2085|zefrai|rien 100 rien)/.test(t) },
      { cle: 'paillettes',  test: t => /paillet/.test(t) },
      { cle: 'metal',       test: t => /(gold|hologramme|argent)/.test(t) },
      { cle: 'fraise',      test: t => /(menthe|turquoise|fluo|blanche fraise|kaki fraise)/.test(t) },
      { cle: 'abeille',     test: t => /abeille/.test(t) },
    ];
    const famille = p => {
      const t = sansAccent(p.title || '');
      const i = FAMILLES.findIndex(f => f.test(t));
      return i === -1 ? FAMILLES.length : i;   // une famille inconnue passe en fin, jamais perdue
    };

    const caps = byCat.get('Casquettes') || []; byCat.delete('Casquettes');
    caps.sort((a, b) => famille(a) - famille(b));   // boutique entiere : les blocs de 3 restent coherents
    const order = ['t-shirt', 'Hoodies', 'Shorts', 'Ensembles', 'Survêtements', ...byCat.keys()];
    const seen = new Set(); const cycle = order.filter(k => byCat.has(k) && !seen.has(k) && seen.add(k));
    const others = [];
    while (cycle.some(k => byCat.get(k).length)) {
      cycle.forEach(k => byCat.get(k).splice(0, 3).forEach(p => others.push(p)));
    }
    const chunks = [];
    for (let i = 0; i < caps.length; i += 3) chunks.push(caps.slice(i, i + 3));
    const step = Math.max(1, Math.floor(others.length / (chunks.length || 1)));
    let oi = 0;
    chunks.forEach(ch => {
      others.slice(oi, oi + step).forEach(p => rank.set(p.handle, n++)); oi += step;
      ch.forEach(p => rank.set(p.handle, n++));
    });
    others.slice(oi).forEach(p => rank.set(p.handle, n++));
    return rank;
  })();

  // Les variantes Shopify sont des "Couleur / Taille" -> on extrait les tailles canoniques
  const CANON = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
  const lireTailles = liste => {
    const out = new Set();
    (liste || []).forEach(v => {
      String(v).split('/').map(x => x.trim().toUpperCase()).forEach(x => { if (CANON.includes(x)) out.add(x); });
      const w = String(v).trim().toUpperCase(); if (CANON.includes(w)) out.add(w);
    });
    return out;
  };
  /* LE FILTRE LIT LES VARIANTES, PAS `p.sizes`.
     `p.sizes` sert aux boutons d'ajout rapide des cartes : il ne garde que les
     variantes vendables, et il est VIDE sur les pieces a deux options (« Red
     Pepper / S ») pour ne pas couvrir la photo de quarante boutons. Deux trous,
     donc, pour un filtre :
       — sur /collections/ensembles il affichait « M L XL » alors que les six
         ensembles ont tous un S et un XS, simplement epuises. Un client qui
         chausse du S en concluait que la marque ne le fait pas, et partait.
       — les pieces a deux options n'etaient JAMAIS retenues par une taille.
     `variants` porte le titre ET la disponibilite de chaque taille, sans trou :
     c'est de lui que viennent les deux lectures ci-dessous. Le filtre montre ce
     que la marque FAIT et grise les ruptures ; « Disponible uniquement » les
     retire. */
  const titresVariantes = p => (p.variants || []).map(v => v.title);
  const taillesOffertes = p => lireTailles(titresVariantes(p));
  const taillesVendables = p => lireTailles((p.variants || []).filter(v => v.available).map(v => v.title));
  const ALL_SIZES = CANON.filter(s => P.some(p => taillesOffertes(p).has(s)));
  const PRICES = P.map(p => p.price);
  const PMIN = Math.floor(Math.min(...PRICES)), PMAX = Math.ceil(Math.max(...PRICES));

  const state = { cat: 'all', sizes: new Set(), colors: new Set(), priceMax: Infinity, avail: false, sort: 'new' };
  const initHash = (location.hash || '').replace('#', '').toLowerCase();
  if (HASH[initHash]) state.cat = HASH[initHash];

  const els = {
    grid: $('[data-shop-grid]'), count: $('[data-count]'), countMot: $('[data-count-mot]'), title: $('[data-shop-title]'),
    cats: $('[data-cats]'), sizes: $('[data-sizes]'), price: $('[data-price]'), priceVal: $('[data-price-val]'),
    avail: $('[data-avail]'), sort: $('[data-sort]'), empty: $('[data-empty]'),
    filters: $('[data-filters]'), backdrop: $('[data-filter-backdrop]'),
    plus: $('[data-plus]'), plusBtn: $('[data-plus-btn]'), plusReste: $('[data-plus-reste]'),
    colors: $('[data-colors]'), colorGroup: $('[data-color-group]'),
  };

  /* Sur une collection ciblee (/collections/casquettes...), la page EST deja une
     categorie : filtrer dedans par categorie n'a aucun sens — choisir
     « T-shirts » depuis les casquettes vidait la grille. Les puces deviennent
     donc des liens vers les autres collections, ce qui reproduit le geste de la
     V2 (ou elles changeaient de rayon) avec les adresses reelles de Shopify.
     Sur « Tous les produits », elles restent des filtres, comme shop.html. */
  /* La page de recherche charge ce fichier mais n'a ni grille filtrable ni
     puces de categorie : sans ce garde-fou, shop.js plantait sur
     `els.cats.innerHTML` (« Cannot set properties of null ») et laissait une
     erreur rouge dans la console de chaque recherche. */
  if (!els.grid || !els.cats || !els.sizes) return;

  const LIENS_CAT = Object.fromEntries(
    Object.entries(RAYONS).filter(([, v]) => v.lien).map(([k, v]) => [k, v.lien]));
  els.cats.innerHTML = _dansLaCollection
    ? CATS.map(c => {
        const href = LIENS_CAT[c.key];
        if (!href) return '';
        const ici = location.pathname.replace(/\/$/, '') === href.replace(/\/$/, '');
        return `<a class="fchip${ici ? ' is-on' : ''}" href="${href}">${c.label}</a>`;
      }).join('')
    : CATS.map(c => `<button class="fchip${c.key === state.cat ? ' is-on' : ''}" data-cat="${c.key}">${c.label}</button>`).join('');
  /* Un rayon peut n'avoir aucune taille — les casquettes sont ajustables. Le
     titre « Taille » restait alors seul au-dessus d'un vide. On masque le
     groupe entier, comme le fait deja le filtre Couleur quand il est inutile. */
  const groupeTaille = els.sizes.closest('.fgroup');

  /* Les puces se redessinent a chaque changement de rayon, comme celles des
     couleurs : une taille epuisee chez les Ensembles peut tres bien etre en
     stock chez les T-shirts. Le calcul se fait sur le rayon courant SEUL,
     jamais sur la grille deja filtree par taille — ce serait circulaire. */
  /* LISTE MANUELLE DES TAILLES, par rayon (window.FN_TAILLES_FILTRE).
     Posee par sections/collection.liquid depuis le reglage de thème, au format
     « Rayon: S,M,L,XL », une ligne par rayon. Elle sert a masquer les tailles
     declarees dans Shopify mais jamais approvisionnees, SANS toucher aux
     variantes ni au stock — donc sans rien casser si on la vide.
     Un rayon absent de la liste garde le comportement automatique : c'est le
     repli sur, et c'est ce qui evite de cacher un XS reellement en stock
     (les Survetements en ont). */
  const TAILLES_MANUELLES = (() => {
    const brut = typeof window.FN_TAILLES_FILTRE === 'string' ? window.FN_TAILLES_FILTRE : '';
    const m = new Map();
    brut.split(/\r?\n/).forEach(ligne => {
      const i = ligne.indexOf(':');
      if (i < 1) return;
      const rayon = ligne.slice(0, i).trim().toLowerCase();
      const tailles = ligne.slice(i + 1).split(',').map(x => x.trim().toUpperCase()).filter(Boolean);
      if (rayon && tailles.length) m.set(rayon, new Set(tailles));
    });
    return m;
  })();
  const taillesAutorisees = cat => TAILLES_MANUELLES.get(String(cat || '').toLowerCase()) || null;
  /* Sur une page de rayon, `state.cat` reste 'all' : la grille est deja
     restreinte par FN_COLLECTION cote serveur, et les pastilles de categorie
     sont alors des LIENS, pas des boutons. Le rayon reel est donc celui que
     pose collection.liquid. Sans ca, la liste manuelle n'etait jamais trouvee. */
  const rayonCourant = () =>
    (_dansLaCollection && window.FN_COLLECTION_CAT) ? window.FN_COLLECTION_CAT : state.cat;

  function majPucesTaille() {
    const duRayon = P.filter(p => state.cat === 'all' || FN.matchCat(p, state.cat));
    const offertes = new Set(), vendables = new Set();
    duRayon.forEach(p => {
      taillesOffertes(p).forEach(s => offertes.add(s));
      taillesVendables(p).forEach(s => vendables.add(s));
    });
    const permises = taillesAutorisees(rayonCourant());
    const utiles = CANON.filter(s => offertes.has(s) && (!permises || permises.has(s)));
    els.sizes.innerHTML = utiles.map(s => {
      const rupture = !vendables.has(s);
      return `<button class="fchip fchip--sz${state.sizes.has(s) ? ' is-on' : ''}${rupture ? ' is-epuise' : ''}"`
        + ` data-size="${s}" aria-pressed="${state.sizes.has(s)}"`
        + (rupture ? ` title="${s} — épuisé pour le moment"` : '')
        + `>${s}${rupture ? '<i class="fchip__rupture" aria-hidden="true"></i><span class="sr-only"> — épuisé</span>' : ''}</button>`;
    }).join('');
    if (groupeTaille) groupeTaille.hidden = utiles.length === 0;
  }
  majPucesTaille();
  /* ---------- FILTRE COULEUR ----------
     La table des teintes (js/couleurs.js) associe chaque couleur aux handles
     qui la portent. Elle a ete etablie a la main sur les 29 casquettes ; elle
     vivait dans une section de l'accueil qui montrait dix pieces deja vues
     cinq ecrans plus haut. Ici, elle trie vraiment.

     Le groupe se masque de lui-meme quand la categorie affichee ne contient
     aucune couleur connue : un filtre qui ne filtre rien est un piege. */
  const COULEURS = Array.isArray(window.FN_COLORS) ? window.FN_COLORS : [];
  const COULEUR_DE = new Map();
  COULEURS.forEach(c2 => (c2.h || []).forEach(h => {
    if (!COULEUR_DE.has(h)) COULEUR_DE.set(h, new Set());
    COULEUR_DE.get(h).add(c2.k);
  }));

  function majGroupeCouleur() {
    if (!els.colors || !els.colorGroup) return;
    // quelles teintes existent parmi les produits de la categorie courante ?
    const dispo = new Set();
    P.forEach(pr => {
      if (state.cat !== 'all' && !FN.matchCat(pr, state.cat)) return;
      (COULEUR_DE.get(pr.handle) || []).forEach(k => dispo.add(k));
    });
    const utiles = COULEURS.filter(c2 => dispo.has(c2.k));
    els.colorGroup.hidden = utiles.length < 2;
    els.colors.innerHTML = utiles.map(c2 => `<button class="fchip fchip--couleur${state.colors.has(c2.k) ? ' is-on' : ''}" data-color="${c2.k}" aria-pressed="${state.colors.has(c2.k)}"><i class="fchip__pastille" style="background:${c2.sw}" aria-hidden="true"></i>${c2.label}</button>`).join('');
  }
  majGroupeCouleur();

  /* LE PAS DOIT PERMETTRE D'ATTEINDRE LE MAXIMUM.
     Avec min=34 et un pas de 5, les valeurs possibles sont 34, 39 … 119, 124 :
     120 n'en fait pas partie, le navigateur rabat donc le curseur sur 119. Les
     trois pieces a 119,90 € — les plus cheres du catalogue — disparaissaient
     des qu'on touchait au curseur, et ne revenaient jamais. */
  els.price.min = PMIN; els.price.max = PMAX; els.price.step = 1; els.price.value = PMAX;
  els.priceVal.textContent = PMAX + ' €';

  /* ---------- BANDEAUX DE RUPTURE (vue « Tout ») ----------
     75 cartes d'un bloc endorment l'oeil : toutes les ~12 cartes, un visuel
     bento pleine largeur annonce la categorie de la carte qui suit et sert
     de raccourci vers son rayon (memes visuels que le bento de la home). */
  /* LES RAYONS VIENNENT DU THEME.
     Visuels, degrades et adresses etaient ecrits ici, en double avec le Liquid
     qui doit poser la banniere des le premier affichage. Deux copies = deux
     verites : la page s'ouvrait sur la photo des casquettes quel que soit le
     rayon. Source unique desormais : window.FN_RAYONS, pose par
     sections/collection.liquid. Les replis ne servent qu'au cas ou le bloc
     manquerait. */
  const BREAK_IMG = Object.fromEntries(
    Object.entries(RAYONS).filter(([k, v]) => k !== 'all' && v.img).map(([k, v]) => [k, v.img]));
  const BREAK_FOND = Object.fromEntries(
    Object.entries(RAYONS).filter(([k, v]) => v.fond).map(([k, v]) => [k, v.fond]));
  const BREAK_HASH = { 'Casquettes': 'casquettes', 't-shirt': 't-shirts', 'Hoodies': 'hoodies', 'Shorts': 'shorts', 'Ensembles': 'ensembles', 'Survêtements': 'survetements', 'Jogging': 'jogging' };
  const FOND_DEFAUT = (RAYONS.all && RAYONS.all.fond) || '';
  /* Le titre se pose sur des fonds clairs (t-shirts) comme sombres : sa
     couleur suit la luminance du degrade, sinon il devient illisible. */
  const FOND_CLAIR = new Set();
  function withBreaks(list) {
    const out = [];
    let lastCat = null;
    list.forEach((p, i) => {
      if (i && i % 12 === 0 && BREAK_IMG[p.cat] && p.cat !== lastCat) {
        out.push(`<a class="shopbreak" href="#${BREAK_HASH[p.cat]}" aria-label="Voir le rayon ${labelOf(p.cat)}">${media(BREAK_IMG[p.cat], `alt="" loading="lazy"`, "100vw")}<span class="shopbreak__meta"><span class="shopbreak__eye">Le rayon</span><span class="shopbreak__name">${labelOf(p.cat)}</span></span></a>`);
        lastCat = p.cat;
      }
      out.push(FN.card(p));
    });
    return out.join('');
  }

  /* transitions de grille : seulement si le navigateur sait faire et
     si l'utilisateur n'a pas demandé moins d'animations */
  const sobre = matchMedia('(prefers-reduced-motion: reduce)');
  const transitionPossible = () =>
    typeof document.startViewTransition === 'function' && !sobre.matches;

  /* un nom par pièce — plafonné : au-delà, le coût de capture dépasse
     le bénéfice visuel, et les cartes du bas ne sont pas à l'écran */
  const PLAFOND_NOMS = 36;
  function nommerCartes() {
    const cartes = els.grid.querySelectorAll('.card');
    cartes.forEach((c, i) => {
      if (i >= PLAFOND_NOMS) { c.style.viewTransitionName = ''; return; }
      const a = c.querySelector('.card__link');
      const h = a && new URLSearchParams((a.getAttribute('href') || '').split('?')[1] || '').get('handle');
      c.style.viewTransitionName = h ? 'p-' + h.replace(/[^a-z0-9-]/gi, '') : '';
    });
  }

  /* ---------- GRILLE PROGRESSIVE ----------
     Un rayon montrait ses 39 pièces d'un coup : 39 photos à télécharger avant
     que la page soit utilisable. Mesuré le 13/10 sur un téléphone en 4G bridée,
     la plus grande image mettait 11 s à s'afficher — le seuil « correct » de
     Google est 2,5 s.

     CE QUI N'EST PAS FAIT, ET POURQUOI
     Les cartes ne sont PAS retirées du HTML. Google lit le code de la page, pas
     ce qui se charge au défilement : retirer vingt-trois produits de la grille,
     c'était défaire le maillage interne construit le jour même. Elles sont donc
     toutes là, simplement masquées — et une image dans un bloc `display:none`
     n'est jamais téléchargée.

     Le repli est le bon : si ce fichier ne s'exécute pas, aucune carte n'est
     masquée et la grille s'affiche entière, exactement comme avant. */
  const PAR_PALIER = 16;
  let montre = PAR_PALIER;

  function limiterGrille() {
    const cartes = $$('.card', els.grid);
    cartes.forEach((c, i) => c.classList.toggle('card--differee', i >= montre));
    /* Le relais, dans la MÊME instruction que la pose des classes : entre les
       deux, le navigateur ne repeint pas, donc aucune image masquée ne part. */
    els.grid.classList.remove('shop__grid--differe');
    const reste = Math.max(0, cartes.length - montre);
    if (!els.plus) return;
    els.plus.hidden = reste === 0;
    if (reste > 0) {
      const lot = Math.min(PAR_PALIER, reste);
      els.plusBtn.textContent = `Voir ${lot} pièce${lot > 1 ? 's' : ''} de plus`;
      els.plusReste.textContent = `${cartes.length - reste} sur ${cartes.length} affichées`;
    } else {
      /* Le compteur porte `aria-live` : laissé tel quel, il garderait « 16 sur
         35 » une fois les 35 montrées, et un lecteur d'écran annoncerait un
         chiffre faux. Masquer le bloc ne suffit pas à le faire taire. */
      els.plusReste.textContent = '';
    }
  }

  function apply(garderPalier) {
    if (!garderPalier) montre = PAR_PALIER;
    let list = P.filter(p => {
      if (state.cat !== 'all' && !FN.matchCat(p, state.cat)) return false;
      if (state.avail && !p.available) return false;
      if (p.price > state.priceMax) return false;
      /* Choisir une taille montre les pieces qui la FONT. Cocher « Disponible
         uniquement » resserre sur celles qui l'ont en stock — c'est la, et
         seulement la, qu'une rupture doit faire disparaitre une piece. */
      if (state.sizes.size) {
        const cs = state.avail ? taillesVendables(p) : taillesOffertes(p);
        if (![...state.sizes].some(s => cs.has(s))) return false;
      }
      if (state.colors.size) {
        const cc = COULEUR_DE.get(p.handle);
        if (!cc || ![...state.colors].some(k => cc.has(k))) return false;
      }
      return true;
    });
    if (state.sort === 'price-asc') list.sort((a, b) => a.price - b.price);
    else if (state.sort === 'price-desc') list.sort((a, b) => b.price - a.price);
    else if (state.sort === 'az') list.sort((a, b) => a.title.localeCompare(b.title));
    else list.sort((a, b) => (RANK.get(a.handle) ?? 999) - (RANK.get(b.handle) ?? 999)); // « En vedette »
    // les produits épuisés toujours en dernier, quel que soit le tri
    list.sort((a, b) => (a.available === false ? 1 : 0) - (b.available === false ? 1 : 0));
    /* ----------------------------------------------------------
       LA GRILLE SE RÉORGANISE AU LIEU DE CLIGNOTER
       Chaque carte porte un nom de transition unique (son handle).
       Le navigateur reconnaît alors les pièces qui restent d'un
       filtre à l'autre et les DÉPLACE physiquement vers leur
       nouvelle case ; celles qui sortent s'effacent, celles qui
       arrivent montent. Rien à animer à la main.
       Les noms sont posés APRÈS chaque rendu : ils doivent déjà
       être en place quand la capture de l'état précédent a lieu.
       ---------------------------------------------------------- */
    const peindre = () => {
      /* Les bandeaux « Le rayon … » annoncent un changement d'univers au milieu
         de la boutique entiere. Dans un rayon, ils annoncent le rayon ou l'on
         est deja — et ils coupent le regroupement par famille en deux. */
      els.grid.innerHTML = (state.cat === 'all' && !_dansLaCollection)
        ? withBreaks(list)
        : list.map(FN.card).join('');
      els.count.textContent = list.length;
      /* « 1 articles » saute aux yeux sur un rayon qui n'a qu'une piece. */
      if (els.countMot) els.countMot.textContent = list.length > 1 ? 'articles' : 'article';
      els.empty.hidden = list.length > 0;
      /* Le titre du bandeau appartient a la collection servie par Shopify.
         L'ecraser par le libelle du filtre affichait « Tout » en haut de
         /collections/casquettes. On ne le touche que sur la boutique entiere. */
      if (!_dansLaCollection) els.title.textContent = labelOf(state.cat);
      nommerCartes();
      /* Un nouveau filtre repart du premier palier : sinon on garderait
         ouverts les 48 produits du filtre precedent sur un rayon qui n'en
         a que six. */
      limiterGrille();
    };

    if (transitionPossible()) {
      /* Une transition peut être annulée par le navigateur si la mise en page
         bouge pendant la capture — typiquement quand on scrolle en même temps
         qu'on filtre. La grille se met alors à jour sans animation, ce qui est
         le bon comportement ; on absorbe le rejet pour ne pas polluer la
         console avec une erreur sans conséquence. */
      const t = document.startViewTransition(peindre);
      t.ready.catch(() => {});
      t.finished.catch(() => {});
    } else peindre();
    /* Banniere : l'image suit la categorie choisie — mais UNIQUEMENT sur
       « Tous les produits ». Sur un rayon, elle a ete posee par le serveur avec
       son degrade ; la recalculer ici la remettait systematiquement sur la
       photo par defaut (celle des casquettes) puisque le filtre vaut 'all'. */
    const heroImg = _dansLaCollection ? null : document.querySelector('[data-shop-hero-img]');
    if (heroImg) {
      const voulue = BREAK_IMG[state.cat] || FN_A('banner-crew-lookbook.webp');
      if (!heroImg.src.endsWith(voulue)) {
        heroImg.classList.add('is-swap');
        const suivante = new Image();
        suivante.onload = () => { heroImg.src = voulue; heroImg.classList.remove('is-swap'); };
        suivante.onerror = () => heroImg.classList.remove('is-swap');
        suivante.src = voulue;
      }
      /* La photo est montrée entière : l'aplat qui porte le titre reprend la
         couleur relevée sur son bord, pour que les deux se rejoignent sans
         démarcation. Sans ça, il faudrait rogner la photo pour remplir. */
      const hero = heroImg.closest('.shop__hero');
      if (hero) {
        hero.style.setProperty('--fond-hero', BREAK_FOND[state.cat] || FOND_DEFAUT);
        hero.classList.toggle('shop__hero--clair', FOND_CLAIR.has(state.cat));
      }
    }
    track(list);
  }

  /* ---------- TRACKING (view_item_list + signaux de merchandising) ---------- */
  let tTimer = null;
  function track(list) {
    const T = window.FN_TRACK; if (!T) return;
    clearTimeout(tTimer);
    tTimer = setTimeout(() => {
      // clé de dédoublonnage : un état de filtre = une impression de liste
      const key = ['shop', state.cat, [...state.sizes].sort().join('+') || 'all',
                   state.priceMax, state.avail ? 'dispo' : 'tout', state.sort].join('|');
      T.viewItemList(list.slice(0, 30), 'shop_grid', 'Boutique — ' + labelOf(state.cat), key);
      if (!list.length) T.custom('no_results', { filter_state: key });
    }, 350);
  }
  const trackFilter = (type, value) => { const T = window.FN_TRACK; if (T) T.custom('filter_apply', { filter_type: type, filter_value: String(value) }); };

  els.cats.addEventListener('click', e => { const b = e.target.closest('[data-cat]'); if (!b) return; state.cat = b.dataset.cat; $$('[data-cat]', els.cats).forEach(x => x.classList.toggle('is-on', x === b)); state.colors.clear(); majGroupeCouleur(); majPucesTaille(); trackFilter('categorie', state.cat); apply(); });
  els.sizes.addEventListener('click', e => { const b = e.target.closest('[data-size]'); if (!b) return; const s = b.dataset.size; if (state.sizes.has(s)) state.sizes.delete(s); else state.sizes.add(s); b.classList.toggle('is-on'); b.setAttribute('aria-pressed', state.sizes.has(s) ? 'true' : 'false'); trackFilter('taille', s); apply(); });
  els.colors && els.colors.addEventListener('click', e => {
    const b = e.target.closest('[data-color]'); if (!b) return;
    const k = b.dataset.color;
    if (state.colors.has(k)) state.colors.delete(k); else state.colors.add(k);
    b.classList.toggle('is-on');
    b.setAttribute('aria-pressed', state.colors.has(k) ? 'true' : 'false');
    trackFilter('couleur', [...state.colors].join(','));
    apply();
  });
  /* Au maximum, le curseur ne filtre plus rien : un prix arrondi a l'entier
     superieur (120) exclurait sinon une piece a 119,90 € selon l'arrondi. */
  els.price.addEventListener('input', () => {
    const v = +els.price.value;
    state.priceMax = v >= PMAX ? Infinity : v;
    els.priceVal.textContent = v + ' €';
    apply();
  });
  els.avail.addEventListener('change', () => { state.avail = els.avail.checked; trackFilter('disponibilite', state.avail); apply(); });
  els.sort.addEventListener('change', () => { state.sort = els.sort.value; trackFilter('tri', state.sort); apply(); });
  $('[data-reset]').addEventListener('click', () => {
    state.cat = 'all'; state.sizes.clear(); state.colors.clear(); state.priceMax = Infinity; state.avail = false; state.sort = 'new';
    $$('[data-cat]', els.cats).forEach(x => x.classList.toggle('is-on', x.dataset.cat === 'all'));
    majPucesTaille();
    majGroupeCouleur();
    els.price.value = PMAX; els.priceVal.textContent = PMAX + ' €'; els.avail.checked = false; els.sort.value = 'new';
    apply();
  });

  /* LE PANNEAU FERME DOIT ETRE HORS D'ATTEINTE, PAS SEULEMENT HORS DE VUE.
     En tiroir, il est pousse par `translateX(-100%)` : invisible a l'oeil, mais
     ses vingt-sept boutons restent dans l'ordre de tabulation et continuent
     d'etre annonces. Un client au clavier ou a VoiceOver traverse donc tout le
     jeu de filtres avant d'atteindre le premier produit, sans rien voir bouger.
     `inert` les retire des deux a la fois.
     Sur ordinateur le panneau est une colonne visible : il ne doit jamais
     devenir inerte — d'ou le controle de la media query. */
  const enTiroir = window.matchMedia('(max-width: 980px)');
  const majInert = () => {
    const ferme = enTiroir.matches && !els.filters.classList.contains('open');
    els.filters.toggleAttribute('inert', ferme);
    els.filters.setAttribute('aria-hidden', ferme ? 'true' : 'false');
  };
  let avantOuverture = null;
  const openF = () => {
    avantOuverture = document.activeElement;
    els.filters.classList.add('open'); majInert();
    els.backdrop.hidden = false; requestAnimationFrame(() => els.backdrop.classList.add('show'));
    const c = els.filters.querySelector('[data-filter-close]'); c && c.focus();
  };
  const closeF = () => {
    els.filters.classList.remove('open'); majInert();
    els.backdrop.classList.remove('show'); setTimeout(() => els.backdrop.hidden = true, 350);
    avantOuverture && avantOuverture.focus && avantOuverture.focus();
  };
  majInert();
  enTiroir.addEventListener('change', majInert);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && els.filters.classList.contains('open')) closeF();
  });
  $('[data-filter-open]').addEventListener('click', openF);
  $('[data-filter-close]').addEventListener('click', closeF);
  els.backdrop.addEventListener('click', closeF);

  addEventListener('hashchange', () => { const h = (location.hash || '').replace('#', '').toLowerCase(); if (HASH[h]) { state.cat = HASH[h]; $$('[data-cat]', els.cats).forEach(x => x.classList.toggle('is-on', x.dataset.cat === state.cat)); apply(); } });

  /* Le bouton ouvre le palier suivant SANS refiltrer : `apply(true)` garde le
     palier courant, alors qu'un changement de filtre le remet a zero. */
  if (els.plus && els.plusBtn) {
    els.plusBtn.addEventListener('click', () => {
      const avant = $$('.card', els.grid).filter(c => !c.classList.contains('card--differee')).length;
      montre += PAR_PALIER;
      limiterGrille();
      /* On amene le regard sur la premiere piece qui vient d'apparaitre, sans
         sauter : sinon le clic ne montre rien, les nouvelles cartes etant sous
         le bouton. */
      const cartes = $$('.card', els.grid);
      const premiere = cartes[avant];
      if (premiere) premiere.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      trackFilter('voir_plus', montre);
    });
  }

  apply();
})();
